// extracted by mini-css-extract-plugin
export default {"refresh":"styles_refresh__Ay31r","refresh__icon":"styles_refresh__icon__vBOBr"};